// @ts-nocheck
import network from './network'
import networkTS from './networkTS'

export default {
  getReminders(ownerId, employeeIds, priority) {
    let employeeFilter = ''
    for (const employeeId of employeeIds) {
      employeeFilter += `&employeeIds=${employeeId}`
    }

    if ((priority !== '' && priority !== null) || (employeeIds.length > 0)) {
      if (priority === null || priority === '') {
        return network.get(`web/calendar/reminder/list/${ownerId}?${employeeFilter.substr(1)}`)
          .then(response => {
            return response.data
          })
      }
      return network.get(`web/calendar/reminder/list/${ownerId}?${employeeFilter.substr(1)}&priority=${priority}`)
        .then(response => {
          return response.data
        })
    } else {
      return network.get(`web/calendar/reminder/list/${ownerId}`)
        .then(response => {
          return response.data
        })
    }
  },
  getReminderById(reminderId) {
    return network.get(`/web/calendar/reminder/${reminderId}`)
      .then(response => {
        return response.data
      })
  },
  createReminder(ownerId, reminder, referenceIds = []) {
    return network.post('/web/calendar/reminder/create', {
      activity: reminder.activity,
      contactId: reminder.contactId,
      date: Math.round(reminder.date.getTime() / 1000),
      done: 0,
      employeeUserId: reminder.employeeUserId,
      ownerId: ownerId,
      priority: reminder.priority,
      referenceIds: referenceIds,
      subject: reminder.subject
    })
      .then(response => {
        return response.data
      })
  },
  createBulkReminder(ownerId, reminder, referenceIds = []) {
    return network.post('/web/calendar/reminder/createBulk', {
      activity: reminder.activity,
      contactId: reminder.contactId,
      date: Math.round(reminder.date.getTime() / 1000),
      done: 0,
      employeeUserId: reminder.employeeUserId,
      ownerId: ownerId,
      priority: reminder.priority,
      buckets: referenceIds.map(bucket => {
        return {
          referenceIds: [bucket]
        }
      }),
      subject: reminder.subject
    })
      .then(response => {
        return response.data
      })
  },
  updateReminder(reminder) {
    return network.post('/web/calendar/reminder/update', {
      id: reminder.id,
      activity: reminder.activity,
      contactId: reminder.contactId,
      date: reminder.date,
      done: reminder.done,
      employeeUserId: reminder.employeeUserId,
      priority: reminder.priority,
      referenceIds: reminder.referenceIds,
      subject: reminder.subject
    })
      .then(response => {
        return response.data
      })
  },
  setDone(ids) {
    return network.post('/web/calendar/reminder/setDone', {
      ids: ids
    })
      .then(response => {
        return response.data
      })
  },
  setUnDone(ids) {
    return network.post('/web/calendar/reminder/setUnDone', {
      ids: ids
    })
      .then(response => {
        return response.data
      })
  },
  updateDate(ids, date) {
    return network.post('/web/calendar/reminder/updateDate', {
      ids: ids,
      date: date
    })
      .then(response => {
        return response.data
      })
  },
  updateEmployee(ids, employeeUserId) {
    return network.post('/web/calendar/reminder/updateEmployee', {
      ids: ids,
      employeeUserId: employeeUserId
    })
      .then(response => {
        return response.data
      })
  },
  updatePriority(ids, priority) {
    return network.post('/web/calendar/reminder/updatePriority', {
      ids: ids,
      priority: priority
    })
      .then(response => {
        return response.data
      })
  },
  countOverdueReminders(ownerId, userId) {
    return network.get(`web/calendar/reminder/countOverdueReminders/${ownerId}/user/${userId}`)
      .then(response => {
        return response.data
      })
  },
  getRemindersByReferenceIds(referenceIds, ownerId = '', includeDone = false) {
    let url = `web/calendar/reminder/listByReferenceIds/${referenceIds}`
    if (ownerId !== '') {
      url += `?ownerId=${ownerId}`
    }
    url += `&includeDone=${includeDone}`
    return network.get(url)
      .then(response => {
        return response.data
      })
  },
  getRemindersByReferenceIds2(referenceIds, ownerId = '', includeDone = false) {
    return networkTS.reminderServiceListByReferenceIds2({ referenceIds: referenceIds, ownerId: ownerId, includeDone: includeDone })
      .then(response => {
        return response.data
      })
  }
}
